import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const FarmerIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M14.5807 20.3761H7.17577C6.35914 20.3761 5.69482 21.097 5.69482 21.9833V25.9479H16.0616V21.9833C16.0616 21.097 15.3973 20.3761 14.5807 20.3761Z" />;
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M8.40277 15.8274C8.28467 15.6994 8.12858 15.6228 7.96313 15.6097V18.8755H13.7886V15.6097C13.6232 15.6228 13.4669 15.6994 13.3484 15.828C12.6881 16.5446 11.8101 16.9393 10.8759 16.9393C9.94168 16.9393 9.06367 16.5446 8.40277 15.8274Z" />;
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M15.1711 15.7554V18.9439C16.4665 19.2411 17.4417 20.4911 17.4417 21.9842V25.9488H19.7616C20.1431 25.9488 20.4529 25.6128 20.4529 25.1986V22.7878C20.4529 19.3251 18.1816 16.4267 15.1711 15.7554Z" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M6.58085 15.7554C3.57035 16.4267 1.29907 19.3251 1.29907 22.7878V25.1986C1.29907 25.6128 1.60873 25.9488 1.99039 25.9488H4.3101V21.9842C4.3101 20.4911 5.28534 19.2411 6.58085 18.9439V15.7554Z" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M20.5028 4.19797H16.7475C16.6953 2.06093 15.0783 0.339844 13.0968 0.339844H8.65401C6.6724 0.339844 5.05553 2.06093 5.00314 4.19797H1.24894C0.867272 4.19797 0.557617 4.5346 0.557617 4.9488C0.557617 6.30922 1.5739 7.41213 2.82746 7.41213H18.9243C20.1778 7.41213 21.1941 6.30922 21.1941 4.9488C21.1941 4.5346 20.8843 4.19797 20.5028 4.19797Z" />;
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M16.0072 9.12676V8.91321H5.73877V9.12676C5.73877 12.2088 8.0376 14.6985 10.8731 14.6985C13.7131 14.6985 16.0072 12.204 16.0072 9.12676Z" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props) {
    t6 = <svg width="22" height="26" viewBox="0 0 22 26" fill="current" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}</svg>;
    $[6] = props;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};